import { FC } from 'react';

import type { IA11yWrapper } from './a11y-wrapper.android';

export const A11yWrapper: FC<IA11yWrapper> = ({ children }) => <>{children}</>;
